
<div class="primary" :class="left?'left-side-button':'right-side-button'">
    <a @click="onClick">
        <div><i class="fas fa-caret-right" :class="{shown:active}"></i></div>
        <p class="primary">{{ title }}</p>
    </a>
</div>
